import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div(
  ({theme}) => css`
    box-sizing: border-box;
    display: grid;
    grid-template-rows: 147px auto;
    flex-shrink: 0;
    width: 280px;
    border-radius: 5px;
    overflow: hidden;
    text-decoration: none;
    color: ${theme.colors.contentPrimary};
    background: ${theme.colors.backgroundPrimary};
    ${theme.elevations.large};
  `
);
